export const REPO_URL: string = "https://github.com/spacebarchat/client";
export const GIT_REVISION: string = "__GIT_REVISION__";
export const GIT_BRANCH: string = "__GIT_BRANCH__";
export const APP_VERSION = "__APP_VERSION__";
